// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-title-main {
  padding-top: var(--spacing-big);
}
.container-table {
  margin-top: var(--spacing-big);
}
.text-title {
  font-size: var(--font-giant);
  font-weight: 600;
  color: var(--color-neutral-dark-darker);
}
.table-concierge .ant-table-cell {
  border-inline-end: none !important;
}
.details-card-title {
  font-size: var(--font-medium);
  font-weight: 600;
  color: var(--color-neutral-dark-darker);
}
.quotation-table .ant-checkbox-indeterminate .ant-checkbox-inner:after {
  background-color: var(--color-highlight);
  height: 50%;
  width: 50%;
}
.quotation-table .ant-checkbox-checked .ant-checkbox-inner {
  background-color: var(--color-highlight);
  border-color: var(--color-highlight);
}
.quotation-table .ant-checkbox-checked:hover .ant-checkbox-inner {
  background-color: var(--color-highlight-darker) !important;
  border-color: var(--color-highlight-darker) !important;
}
.quotation-table .ant-checkbox-inner {
  border-radius: var(--border-radius-input) !important;
}
.quotation-table .ant-table-tbody > tr.ant-table-row-selected > td {
  background: none !important;
  border-color: none;
}
.quotation-table .ant-table-tbody > tr.ant-table-row-selected:hover > td {
  background: none !important;
}
.item-quotation-disabled {
  color: var(--color-neutral-light);
}
.item-quotation-disabled::after {
  position: absolute;
  left: 0;
  top: 50%;
  height: 1px;
  background: var(--color-neutral-light);
  content: "";
  width: 100%;
  display: block;
}
.manage-concierge-table-bottom-infos {
  margin-top: var(--spacing-small);
}
.manage-concierge-table-bottom-infos .table-caption span {
  text-decoration: line-through;
}
.manage-concierge-table-bottom-infos .solicitation-total-value {
  font-size: var(--font-giant);
}
.manage-concierge-table-bottom-infos .solicitation-total-value span {
  font-weight: 700;
}
.container-solicitation-status {
  margin-top: var(--spacing-small);
  background-color: var(--color-neutral-light-lighter);
  padding-top: var(--spacing-small);
  padding-left: var(--spacing-small);
  padding-right: var(--spacing-small);
}
.details-card-title {
  font-size: var(--font-medium);
  font-weight: 600;
  color: var(--color-neutral-dark-darker);
}
.solicitation-status-title {
  margin-right: var(--spacing-extra-small);
}
.container-last-actions {
  padding-top: var(--spacing-small);
  padding-right: var(--spacing-small);
  padding-left: var(--spacing-small);
}
.concierge-history-actions {
  padding-bottom: var(--spacing-regular);
  padding-left: var(--spacing-small);
}
.concierge-history-action-item {
  border-left: 2px solid var(--color-border);
}
.concierge-history-last-action {
  border-left: 2px solid var(--color-neutral-light-lighter);
}
.concierge-history-concluded:before {
  content: "✓" !important;
  background-color: var(--success-color) !important;
  border: 1px solid var(--success-color) !important;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: var(--color-white);
  font-size: var(--font-small);
}
.concierge-history-in-approval:before {
  content: "" !important;
  background-color: var(--color-warning) !important;
  border: 1px solid var(--color-warning) !important;
  color: var(--color-warning);
}
.concierge-history-pending:before {
  content: "" !important;
  background-color: var(--color-neutral-light) !important;
  border: 1px solid var(--color-neutral-light) !important;
  color: var(--color-neutral-light);
}
.concierge-history-canceled:before {
  content: "✗" !important;
  background-color: var(--error-color) !important;
  border: 1px solid var(--error-color) !important;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: var(--color-white);
  font-size: var(--font-small);
}
.concierge-history-actions:before {
  content: '';
  height: var(--spacing-small);
  width: var(--spacing-small);
  background-color: var(--color-border);
  border: 1px solid var(--color-border);
  border-radius: 50%;
  position: absolute;
  margin-left: -26px;
}
.container-actions-history-main {
  display: flex;
  flex-direction: column;
}
.container-actions-history-sub {
  display: flex;
  flex-direction: column;
}
@media (max-width: 768px) {
  .container-actions-history-sub {
    flex-direction: column;
  }
}
.span-date-history {
  margin-top: var(--spacing-extra-small);
  font-size: var(--font-small);
  color: var(--color-neutral-dark);
}
.span-status-description {
  font-size: var(--font-small);
  font-weight: 400;
  color: var(--color-neutral-dark-lighter);
}
.margin-top-small {
  margin-top: var(--spacing-small);
}
.margin-top-big {
  margin-top: var(--spacing-big);
}
.manage-solicitation-supplier {
  margin-right: var(--spacing-extra-small);
}
.margin-bottom-small {
  margin-bottom: var(--spacing-small);
}
.text-align-center {
  text-align: center;
}
.container-table-concierge-details {
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
  border-radius: var(--spacing-small);
}
.container-action-history-empty {
  padding-bottom: var(--spacing-small);
}
.container-radio-supplier {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.container-quotation-file {
  margin-left: 16px;
  border-radius: var(--border-radius-input) !important;
}
.container-quotation-file:hover {
  border-color: var(--color-highlight);
}
.action-motivation span,
.action-note span {
  color: var(--color-neutral-dark);
  font-weight: 500;
}
.action-motivation .muted,
.action-note .muted {
  color: var(--color-neutral-dark-lighter);
  font-weight: 400;
}
.concierge-ol-infos {
  list-style-type: decimal;
  padding-left: 20px;
  gap: 10px;
  display: flex;
  flex-direction: column;
}
.concierge-ol-infos li::marker {
  font-weight: bold;
}
@media (max-width: 600px) {
  .custom-col {
    width: 100% !important;
    display: inline-grid;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/pages/concierge/ManageConciergeSolicitationStyles.less"],"names":[],"mappings":"AAAA;EACI,+BAAA;AACJ;AAEA;EACI,8BAAA;AAAJ;AAGA;EACI,4BAAA;EACA,gBAAA;EACA,uCAAA;AADJ;AAIA;EACI,kCAAA;AAFJ;AAKA;EACI,6BAAA;EACA,gBAAA;EACA,uCAAA;AAHJ;AAMA;EAEQ,wCAAA;EACA,WAAA;EACA,UAAA;AALR;AACA;EASY,wCAAA;EACA,oCAAA;AAPZ;AAHA;EAgBY,0DAAA;EACA,sDAAA;AAVZ;AAPA;EAsBQ,oDAAA;AAZR;AAVA;EA0BQ,2BAAA;EACA,kBAAA;AAbR;AAdA;EA+BQ,2BAAA;AAdR;AAkBA;EACI,iCAAA;AAhBJ;AAmBA;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,sCAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;AAjBJ;AAoBA;EACI,gCAAA;AAlBJ;AAiBA;EAKY,6BAAA;AAnBZ;AAcA;EAUQ,4BAAA;AArBR;AAWA;EAaY,gBAAA;AArBZ;AA0BA;EACI,gCAAA;EACA,oDAAA;EACA,iCAAA;EACA,kCAAA;EACA,mCAAA;AAxBJ;AA2BA;EACI,6BAAA;EACA,gBAAA;EACA,uCAAA;AAzBJ;AA4BA;EACI,wCAAA;AA1BJ;AA6BA;EACI,iCAAA;EACA,mCAAA;EACA,kCAAA;AA3BJ;AA8BA;EACI,sCAAA;EACA,kCAAA;AA5BJ;AA+BA;EACI,0CAAA;AA7BJ;AAgCA;EACI,yDAAA;AA9BJ;AAiCA;EACI,uBAAA;EACA,iDAAA;EACA,iDAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,4BAAA;AA/BJ;AAkCA;EACI,sBAAA;EACA,iDAAA;EACA,iDAAA;EACA,2BAAA;AAhCJ;AAmCA;EACI,sBAAA;EACA,uDAAA;EACA,uDAAA;EACA,iCAAA;AAjCJ;AAoCA;EACI,uBAAA;EACA,+CAAA;EACA,+CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,4BAAA;AAlCJ;AAqCA;EACI,WAAA;EACA,4BAAA;EACA,2BAAA;EACA,qCAAA;EACA,qCAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AAnCJ;AAsCA;EACI,aAAA;EACA,sBAAA;AApCJ;AAuCA;EACI,aAAA;EACA,sBAAA;AArCJ;AAuCI;EAAA;IACI,sBAAA;EApCN;AACF;AAuCA;EACI,sCAAA;EAEA,4BAAA;EACA,gCAAA;AAtCJ;AAyCA;EACI,4BAAA;EACA,gBAAA;EACA,wCAAA;AAvCJ;AA0CA;EACI,gCAAA;AAxCJ;AA2CA;EACI,8BAAA;AAzCJ;AA4CA;EACI,wCAAA;AA1CJ;AA6CA;EACI,mCAAA;AA3CJ;AA8CA;EACI,kBAAA;AA5CJ;AA+CA;EACI,+CAAA;EACA,mCAAA;AA7CJ;AAgDA;EACI,oCAAA;AA9CJ;AAiDA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AA/CJ;AAkDA;EACI,iBAAA;EACA,oDAAA;AAhDJ;AAmDA;EACI,oCAAA;AAjDJ;AAoDA;;EAGQ,gCAAA;EACA,gBAAA;AAnDR;AA+CA;;EAQQ,wCAAA;EACA,gBAAA;AAnDR;AAuDA;EACI,wBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;AArDJ;AAgDA;EAQQ,iBAAA;AArDR;AA0DA;EACI;IACI,sBAAA;IACA,oBAAA;EAxDN;AACF","sourcesContent":[".container-title-main {\n    padding-top: var(--spacing-big);\n}\n\n.container-table {\n    margin-top: var(--spacing-big);\n}\n\n.text-title {\n    font-size: var(--font-giant);\n    font-weight: 600;\n    color: var(--color-neutral-dark-darker);\n}\n\n.table-concierge .ant-table-cell {\n    border-inline-end: none !important;\n}\n\n.details-card-title {\n    font-size: var(--font-medium);\n    font-weight: 600;\n    color: var(--color-neutral-dark-darker);\n}\n\n.quotation-table {\n    .ant-checkbox-indeterminate .ant-checkbox-inner:after {\n        background-color: var(--color-highlight);\n        height: 50%;\n        width: 50%;\n    }\n\n    .ant-checkbox-checked {\n        .ant-checkbox-inner {\n            background-color: var(--color-highlight);\n            border-color: var(--color-highlight);\n        }\n    }\n\n    .ant-checkbox-checked:hover {\n        .ant-checkbox-inner {\n            background-color: var(--color-highlight-darker) !important;\n            border-color: var(--color-highlight-darker) !important;\n        }\n    }\n\n    .ant-checkbox-inner {\n        border-radius: var(--border-radius-input) !important;\n    }\n\n    .ant-table-tbody>tr.ant-table-row-selected>td {\n        background: none !important;\n        border-color: none;\n    }\n\n    .ant-table-tbody>tr.ant-table-row-selected:hover>td {\n        background: none !important;\n    }\n}\n\n.item-quotation-disabled {\n    color: var(--color-neutral-light);\n}\n\n.item-quotation-disabled::after {\n    position: absolute;\n    left: 0;\n    top: 50%;\n    height: 1px;\n    background: var(--color-neutral-light);\n    content: \"\";\n    width: 100%;\n    display: block;\n}\n\n.manage-concierge-table-bottom-infos {\n    margin-top: var(--spacing-small);\n\n    .table-caption {\n        span {\n            text-decoration: line-through;\n        }\n    }\n\n    .solicitation-total-value {\n        font-size: var(--font-giant);\n\n        span {\n            font-weight: 700;\n        }\n    }\n}\n\n.container-solicitation-status {\n    margin-top: var(--spacing-small);\n    background-color: var(--color-neutral-light-lighter);\n    padding-top: var(--spacing-small);\n    padding-left: var(--spacing-small);\n    padding-right: var(--spacing-small);\n}\n\n.details-card-title {\n    font-size: var(--font-medium);\n    font-weight: 600;\n    color: var(--color-neutral-dark-darker);\n}\n\n.solicitation-status-title {\n    margin-right: var(--spacing-extra-small);\n}\n\n.container-last-actions {\n    padding-top: var(--spacing-small);\n    padding-right: var(--spacing-small);\n    padding-left: var(--spacing-small);\n}\n\n.concierge-history-actions {\n    padding-bottom: var(--spacing-regular);\n    padding-left: var(--spacing-small);\n}\n\n.concierge-history-action-item {\n    border-left: 2px solid var(--color-border);\n}\n\n.concierge-history-last-action {\n    border-left: 2px solid var(--color-neutral-light-lighter);\n}\n\n.concierge-history-concluded:before {\n    content: \"✓\" !important;\n    background-color: var(--success-color) !important;\n    border: 1px solid var(--success-color) !important;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    color: var(--color-white);\n    font-size: var(--font-small);\n}\n\n.concierge-history-in-approval:before {\n    content: \"\" !important;\n    background-color: var(--color-warning) !important;\n    border: 1px solid var(--color-warning) !important;\n    color: var(--color-warning);\n}\n\n.concierge-history-pending:before {\n    content: \"\" !important;\n    background-color: var(--color-neutral-light) !important;\n    border: 1px solid var(--color-neutral-light) !important;\n    color: var(--color-neutral-light);\n}\n\n.concierge-history-canceled:before {\n    content: \"✗\" !important;\n    background-color: var(--error-color) !important;\n    border: 1px solid var(--error-color) !important;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    color: var(--color-white);\n    font-size: var(--font-small);\n}\n\n.concierge-history-actions:before {\n    content: '';\n    height: var(--spacing-small);\n    width: var(--spacing-small);\n    background-color: var(--color-border);\n    border: 1px solid var(--color-border);\n    border-radius: 50%;\n    position: absolute;\n    margin-left: -26px;\n}\n\n.container-actions-history-main {\n    display: flex;\n    flex-direction: column;\n}\n\n.container-actions-history-sub {\n    display: flex;\n    flex-direction: column;\n\n    @media (max-width: 768px) {\n        flex-direction: column;\n    }\n}\n\n.span-date-history {\n    margin-top: var(--spacing-extra-small);\n\n    font-size: var(--font-small);\n    color: var(--color-neutral-dark);\n}\n\n.span-status-description {\n    font-size: var(--font-small);\n    font-weight: 400;\n    color: var(--color-neutral-dark-lighter);\n}\n\n.margin-top-small {\n    margin-top: var(--spacing-small);\n}\n\n.margin-top-big {\n    margin-top: var(--spacing-big)\n}\n\n.manage-solicitation-supplier {\n    margin-right: var(--spacing-extra-small);\n}\n\n.margin-bottom-small {\n    margin-bottom: var(--spacing-small);\n}\n\n.text-align-center {\n    text-align: center;\n}\n\n.container-table-concierge-details {\n    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);\n    border-radius: var(--spacing-small);\n}\n\n.container-action-history-empty {\n    padding-bottom: var(--spacing-small);\n}\n\n.container-radio-supplier {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.container-quotation-file {\n    margin-left: 16px;\n    border-radius: var(--border-radius-input) !important;\n}\n\n.container-quotation-file:hover {\n    border-color: var(--color-highlight);\n}\n\n.action-motivation,\n.action-note {\n    span {\n        color: var(--color-neutral-dark);\n        font-weight: 500;\n    }\n\n    .muted {\n        color: var(--color-neutral-dark-lighter);\n        font-weight: 400;\n    }\n}\n\n.concierge-ol-infos {\n    list-style-type: decimal;\n    padding-left: 20px;\n    gap: 10px;\n    display: flex;\n    flex-direction: column;\n\n    li::marker {\n        font-weight: bold;\n    }\n}\n\n\n@media (max-width: 600px) {\n    .custom-col {\n        width: 100% !important;\n        display: inline-grid;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
